import React, { useState } from 'react';
import { Guid } from '@Shared.Angular/@types/guid';
import FlowStepTagsModal from './FlowStepTags/FlowStepTagsModal';
import { useService } from '@Shared.Angular/flowingly.hooks/useService';
import { SharedAngular } from '@Client/@types/sharedAngular';

type Props = {
  stepName: string;
  stepTagIds: Guid[];
};

const FlowStepTagsIcon = ({ stepName, stepTagIds }: Props) => {
  const [open, setOpen] = useState(false);
  const { enableTagging } = useService<SharedAngular.APP_CONFIG>('APP_CONFIG');

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  if (!enableTagging) return null;
  return (
    <>
      <span
        className="far fa-tag fa-flip-horizontal flow-step-tags-icon-container"
        onClick={handleOpen}
      ></span>
      {open && (
        <FlowStepTagsModal
          stepName={stepName}
          stepTagIds={stepTagIds}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default FlowStepTagsIcon;
